module.exports = __webpack_public_path__ + "static/891026540.4b5448ba.jpg";